<script setup lang="ts">
import { useI18n } from 'vue-i18n';

interface Props {
  submitButtonDisabledDueRrd: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  submitButtonDisabledDueRrd: false,
});

const { t } = useI18n();
</script>

<template>
  <div class="info-container">
    <p v-if="submitButtonDisabledDueRrd">
      {{ t('viewOrder.submit_button_disabled_rrd') }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.info-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1440px;
  margin: 1rem auto;
  border-radius: 0.5rem;
  background-color: var(--secondary-color);
  color: var(--secondary-text-color);
}
</style>
